import n from"exenv";const o=()=>!n.canUseDOM;export{o as useIsSsr};
